/*
 * Copyright 2020 American Express Travel Related Services Company, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
*/

const markets:Record<string,string> =  {
  'de-AT': 'de-at',
  'de-DE': 'de',
  'de-CH': 'de-ch',
  'en-AR': 'en',
  'en-AT': 'en',
  'en-AU': 'en-au',
  'en-BE': 'en',
  'en-BH': 'en',
  'en-CA': 'en-ca',
  'en-CH': 'en',
  'en-DE': 'en',
  'en-ES': 'en',
  'en-FI': 'en',
  'en-FR': 'en',
  'en-GB': 'en-gb',
  'en-HK': 'en',
  'en-ID': 'en',
  'en-IN': 'en-in',
  'en-JP': 'en',
  'en-LU': 'en',
  'en-MX': 'en',
  'en-MY': 'en',
  'en-NL': 'en',
  'en-NO': 'en',
  'en-NZ': 'en-nz',
  'en-SA': 'en',
  'en-SE': 'en',
  'en-SG': 'en-sg',
  'en-TH': 'en',
  'en-US': 'en',
  'en-XA': 'en',
  'en-XB': 'en',
  'es-AR': 'es',
  'es-ES': 'es',
  'es-MX': 'es',
  'es-XA': 'es',
  'es-XB': 'es',
  'fi-FI': 'fi',
  'fr-BE': 'fr',
  'fr-CA': 'fr-ca',
  'fr-CH': 'fr-ch',
  'fr-FR': 'fr',
  'fr-LU': 'fr',
  'fr-XA': 'fr',
  'it-IT': 'it',
  'ja-JP': 'ja',
  'nb-NO': 'nb',
  'nl-BE': 'nl-be',
  'nl-NL': 'nl',
  'nl-LU': 'nl',
  'sv-FI': 'sv',
  'sv-SE': 'sv',
  'th-TH': 'th',
  'zh-CN': 'zh-cn',
  'zh-HK': 'zh-hk',
  'zh-TW': 'zh-tw',
};

export default markets;
